<template>
    <!-- 页面底部 -->
    <div>
        <div class="container foot-bd">
            <!-- 中文版 -->
            <div v-if="langluageType == 'ch'" class="foot-wrapper wrapper" style="margin: 0 auto;">
                <div class="main-foot" style="height: 134px;">
                    <div class="fl foot-logo-saas">
                        <span class="footer-logo">
                            <img src="../assets/foot-logo.svg" alt="" />
                        </span>
                    </div>
                     <div class="fl foot-right-main">
                        <ul class="clearfix">
                            <!-- <li><a href="https://www.exposcm.com/page/about.html">关于我们</a></li> -->
                            <li><a href="javascript:;" class="j-lxwm">联系方式</a></li>
                        </ul>
                        <ul class="clearfix">
                            <li>
                                <p>
                                    Copyright©2018&nbsp;&nbsp;&nbsp;ExpoPaaS&nbsp;&nbsp;
                                    <a href="https://beian.miit.gov.cn" target="_blank">鄂ICP备2024079859号-1</a>
                                </p>
                            </li>
                            <li><el-link :underline="false" href="use" style="font-size: 12px;">注册条款</el-link></li>
                            <li><el-link :underline="false" href="privacy" style="font-size: 12px;">隐私条款</el-link></li>
                            <li><el-link :underline="false" href="safe" style="font-size: 12px;">安全产品、服务和功能隐私声明</el-link></li>
                            <li><el-link :underline="false" href="cookie" style="font-size: 12px;">Cookie声明</el-link></li>
                        </ul>
                    </div>
                </div>
            </div>
            <!-- 英文版 -->
            <div v-else class="foot-wrapper wrapper" style="margin: 0 auto;width: 1600px;display: flex;justify-content: center;">
                <!-- <div class="main-foot" style="height: 60px;margin: 0;width: 1600px;padding-left: 0;padding-bottom: 0px;margin-top: 10px;">
                    <div class="fl foot-logo-saas" style="margin-left: 256px;margin-right: 0;">
                        <span class="footer-logo" style="margin-top: 0;">
                            <img src="../assets/foot-logo.svg" alt="" />
                        </span>
                    </div>
                    <div class="clearfix" style="width: 722.5px;margin: 0 auto;">
                        <div class="fl" style="font-size: 14px;margin-top: 19.2px;">
                            <div><i class="el-icon-message" style="color: rgb(169, 169, 169);margin-right: 10px;"></i><a style="color:#fff;" href="javascript:;">service@exposaas.com</a></div>
                        </div>
                    </div>
                </div> -->
                <!-- <div style="text-align: center;color:#A9A9A9;margin-bottom: 40px;">
                    <span>
                    Copyright©2018&nbsp;ExpoSaaS&nbsp;&nbsp;&nbsp;ExpoSaaS(会展云）&nbsp;&nbsp;
                    <span>Beijing Public Security Network No. 11010502034153</span>
                    &nbsp;&nbsp;
                    <a style="color:#A9A9A9" href="https://beian.miit.gov.cn" target="_blank">Beijing ICP No. 17015357-2</a>
                </span>
                </div> -->
                <div style="margin-top: 32px;position: relative;">
                    <div style="width: 100px;position: absolute;left: -141px;top:2px;">
                        <span class="footer-logo" style="margin-top: 0;">
                            <img src="../assets/foot-logo.svg" alt="" />
                        </span>
                    </div>
                    <div class="clearfix" style="width: 336px;margin: 0 auto;margin-bottom: 23px;margin-left: 0 !important;">
                        <div class="fl" style="font-size: 14px;margin-top: 19.2px;">
                            <div><i class="el-icon-message" style="color: rgb(169, 169, 169);margin-right: 10px;"></i><a style="color:#fff;vertical-align: text-bottom;" href="javascript:;">service@exposaas.com</a></div>
                        </div>
                    </div>
                    <div style="text-align: center;color:#A9A9A9;margin-bottom: 40px;">
                        <span>
                            <!-- <span>Beijing Public Security Network No. 11010502034153</span>&nbsp;&nbsp; -->
                            Copyright©2018&nbsp;ExpoPaaS&nbsp;&nbsp;&nbsp;
                            <a style="color:#A9A9A9" href="https://beian.miit.gov.cn" target="_blank">HuBei ICP No. 2024079859-1</a>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <!-- 联系我们 中文 弹窗 -->
        <div v-if="langluageType == 'ch'" class="j-pop-lxwm" style="display: none; position:fixed; z-index:999999; top:0; left:0; width: 100vw;height: 100vh; background: rgba(0,0,0,.5)">
            <div class="j-pop" style="padding: 50px; 
                        background: #fff; 
                        box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.22);
                        border-radius: 7px;
                        position:absolute;
                        left: 50%;
                        top: 50%;
                        text-align:center;
                        color: #303133;
                        font-size: 16px;
                        font-weight: 600;
                        transform: translate(-50%, -50%);">
                <!-- <p style="color:#606266">咨询热线</p>
                <p style="font-size: 30px; margin-bottom: 20px; margin-top: 5px">010-86460766-861</p> -->
                <p style="color:#606266">企微客服</p>
                <img style="width: 176px; margin-top: 5px; margin-bottom: 20px;" src="../assets/image/newCode.png" alt="">
                <!-- <p style="color:#606266">咨询邮箱</p>
                <p style="font-size: 30px; margin-top: 5px;margin-bottom: 20px;">info@exposcm.com</p> -->
                
            </div>
        </div>
        <!-- 联系我们 英文 弹窗 -->
        <div v-else class="j-pop-lxwm" style="display: none; position:fixed; z-index:999999; top:0; left:0; width: 100vw;height: 100vh; background: rgba(0,0,0,.5)">
            <div class="j-pop" style="padding: 50px; 
                        background: #fff; 
                        box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.22);
                        border-radius: 7px;
                        position:absolute;
                        left: 50%;
                        top: 50%;
                        text-align:center;
                        color: #303133;
                        font-size: 16px;
                        font-weight: 600;
                        transform: translate(-50%, -50%);">
                <p style="color:#606266">Hotline</p>
                <p style="font-size: 30px; margin-bottom: 20px; margin-top: 5px">010-86460766-861</p>
                <p style="color:#606266">Consultation Email</p>
                <p style="font-size: 30px; margin-top: 5px;margin-bottom: 20px;">yingjie@exposcm.com</p>
                <p style="color:#606266">Enterprise WeChat Customer Service</p>
                <img style="width: 176px; margin-top: 5px; margin-bottom: 20px;" src="../assets/image/newCode.png" alt="">
            </div>
        </div>
        
        
    </div>
  
  </template>
  
  <script>
  import $ from 'jquery'
  window.onload = function(){
        // 联系我们
        $('.j-lxwm').on('click',function(){
            $('.j-pop-lxwm').show();
        })

        $(".j-pop").click(function(e){
            e.stopPropagation();

        });
        $(".j-pop-lxwm").click(function(e){
            $(this).hide()

        });
    }
  export default {
    data() {
      return {
        langluageType:sessionStorage.getItem('langluageType')||'ch'
      };
    },
    mounted() {
  
    },
    methods: {
    }
  }
  </script>
  <style scoped>
  .afterStyle::after{
        content: '';
        display: block;
        width: 46px;
        height: 2px;
        background-color: #FFCF00;
    }
  </style>
  


// WEBPACK FOOTER //
// src/components/Footer.vue